import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="rules"
export default class extends Controller {
  static targets = ["editor", "ruleSelect"];
  declare editorTarget: HTMLInputElement;
  declare ruleSelectTarget: HTMLInputElement;

  connect() {
    this.ruleSelectTarget.addEventListener("change", (event) => {
      this.updateRuleName(event.target);
    });
  }

  updateRuleName(select) {
    const ruleName = select.value;
    const exampleBody = this.getExampleBodyForRule(ruleName);

    this.editorTarget.value = JSON.stringify(
      { rule: ruleName, value: exampleBody },
      null,
      2,
    );
    this.editorTarget.hidden = false;
  }

  getExampleBodyForRule(ruleName) {
    switch (ruleName) {
      case "pipeline.trigger_build.pipeline":
        return {
          triggering_pipeline_uuid: "pipeline-uuid",
          triggered_pipeline_uuid: "pipeline-uuid",
        };
      default:
        return {};
    }
  }
}
